import { get, post, patch, del } from "@insite/client-framework/Services/ApiService";

export interface AddOrUpdateDivisionApiModel {
    id?: string;
    name: string;
    brandIds?: string[];
}

export interface DivisionModel {
    uri?: any;
    id: string;
    name: string;
    productTypeCount: number;
    brandIds?: string[];
}

export interface DivisionCollectionModel {
    divisionModels: DivisionModel[];
    pagination?: {
        currentPage: number;
        page: number;
        pageSize: number;
        totalItemCount: number;
        numberOfPages: number;
    };
}

const baseUrl = "/api/v2/centroconnect/sme/admin/division";

export function addDivision(model: AddOrUpdateDivisionApiModel) {
    return post<AddOrUpdateDivisionApiModel, DivisionModel>(baseUrl, model as any);
}

export function getDivisionCollection(page?: number, pageSize?: number, query?: string) {
    const params = new URLSearchParams();
    if (page !== undefined) {
        params.append("page", page.toString());
    }
    if (pageSize !== undefined) {
        params.append("pageSize", pageSize.toString());
    }
    if (query !== undefined) {
        params.append("query", query.trim());
    }
    const url = params.toString() ? `${baseUrl}?${params.toString()}` : baseUrl;
    return get<DivisionCollectionModel>(url);
}

export function updateDivision(model: AddOrUpdateDivisionApiModel) {
    return patch<any>(baseUrl, model as any) as Promise<DivisionModel>;
}

export function deleteDivision(divisionId: string) {
    return del(`${baseUrl}/${divisionId}`) as Promise<void>;
}

export const getDivisionById = async (divisionId: string): Promise<DivisionModel> => {
    return get<DivisionModel>(`${baseUrl}/${divisionId}`);
};
